import { useCallback, useMemo } from 'react'

import { useMissingComplianceDetails } from '../../../hooks/missingComplianceDetails/useMissingComplianceDetails'
import { MissingComplianceDetailsModalStateId } from '../enums/missingComplianceDetailsModalStateId'

export const useMissingComplianceDetailsModalStateId = () => {
  const { isMissingCompanyDetails, isMissingCustomerDetails } = useMissingComplianceDetails()

  const initialStateId = useMemo(() => {
    if (isMissingCompanyDetails) {
      return MissingComplianceDetailsModalStateId.MissingCompanyDetails
    } else if (isMissingCustomerDetails) {
      return MissingComplianceDetailsModalStateId.MissingCustomerDetails
    }
  }, [isMissingCompanyDetails, isMissingCustomerDetails])

  const getNextStateId = useCallback(
    (currentStateId: MissingComplianceDetailsModalStateId) => {
      const isCurrentStateIdCompanyDetails =
        currentStateId === MissingComplianceDetailsModalStateId.MissingCompanyDetails
      if (isCurrentStateIdCompanyDetails && isMissingCustomerDetails) {
        return MissingComplianceDetailsModalStateId.MissingCustomerDetails
      }
    },
    [isMissingCustomerDetails],
  )

  return {
    getNextStateId,
    initialStateId,
  }
}
